var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import Dialog from "@material-ui/core/Dialog";
import { DialogLayoutCentered } from "./layout/DialogLayoutCentered";
import { DialogLayoutSide } from "./layout/DialogLayoutSide";
import { SideDialog } from "../SideDialog";
export var DialogComposer = React.forwardRef(function DialogComposer(_a, ref) {
    var _b = _a.variant, variant = _b === void 0 ? "dialog" : _b, anchor = _a.anchor, dialogTitle = _a.dialogTitle, DialogTitleProps = _a.DialogTitleProps, onClickReturn = _a.onClickReturn, ReturnButtonProps = _a.ReturnButtonProps, onClose = _a.onClose, displayClose = _a.displayClose, onClickClose = _a.onClickClose, CloseButtonProps = _a.CloseButtonProps, children = _a.children, DialogContentProps = _a.DialogContentProps, dialogActions = _a.dialogActions, DialogActionsProps = _a.DialogActionsProps, TitleTypographyProps = _a.TitleTypographyProps, props = __rest(_a, ["variant", "anchor", "dialogTitle", "DialogTitleProps", "onClickReturn", "ReturnButtonProps", "onClose", "displayClose", "onClickClose", "CloseButtonProps", "children", "DialogContentProps", "dialogActions", "DialogActionsProps", "TitleTypographyProps"]);
    var Component = variant === "sideDialog" ? SideDialog : Dialog;
    var renderLayout = function () {
        var baseProps = {
            dialogTitle: dialogTitle,
            DialogTitleProps: DialogTitleProps,
            onClose: onClose,
            displayClose: displayClose,
            onClickClose: onClickClose,
            CloseButtonProps: CloseButtonProps,
            children: children,
            DialogContentProps: DialogContentProps,
            dialogActions: dialogActions,
            DialogActionsProps: DialogActionsProps,
            TitleTypographyProps: TitleTypographyProps,
        };
        switch (variant) {
            case "dialog":
                return React.createElement(DialogLayoutCentered, __assign({}, baseProps));
            case "sideDialog":
                return (React.createElement(DialogLayoutSide, __assign({}, baseProps, { onClickReturn: onClickReturn, ReturnButtonProps: ReturnButtonProps })));
            default:
                return children;
        }
    };
    return (React.createElement(Component, __assign({ anchor: variant === "sideDialog" ? anchor : undefined, onClose: onClose }, props, { ref: ref }), renderLayout()));
});
//# sourceMappingURL=DialogComposer.js.map